<template>
  <div class="header relative center">
    <div class="back absolute" :class="[isStartHash()?'home':'',isWeixin?'weixin':'']" @click.stop="doBackMixin_doBack">
      <slot name="back"></slot>
    </div>
    <div class="close absolute fs16 color_main" @click="nativeBack" v-if="showCloseBtn">关闭</div>
    <slot name="right"></slot>
    <slot name="middle"></slot>
    <span v-if="!$slots.middle" class="middle ellipsis flex flex-center flex-center-2" ref="middle">
      <img :src="img|docAva" v-if="Object.keys(img).length>0" alt="" class="radius50 mr10 flex0">
      <font class="flex0 ellipsis">{{ title }}</font>
    </span>
  </div>
</template>

<script>
import docAva from '../utils/docAva'
import {doBackMixin, jssdkMixin} from "../lib/mixin";
import {isEmpty} from "@/lib/util";

export default {
  props: {
    img: {
      type: Object,
      default: () => {
        return {}
      }
    },
    mobileHidden: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      repeat: 0,
    };
  },
  computed: {
    showCloseBtn() {
      return !isEmpty(window.vm) && location.hash !== window.startHash && this.isMobile;
    }
  },
  filters: {docAva},
  components: {},
  mixins: [jssdkMixin, doBackMixin],
  mounted() {
    bus && bus.$on('androidCallBack', () => {
      this.doBackMixin_doBack();
    });
    this.initMiddle();
  },
  beforeDestroy() {

  },
  methods: {
    initMiddle() {
      const el = this.$refs.middle;
      if (el) {
        const rect = el.getBoundingClientRect();
        if (rect.width > 0) {
          const img = el.querySelector('img');
          const font = el.querySelector('font');
          if (img) {
            const imgCss = window.getComputedStyle && getComputedStyle(img);
            // console.log(imgCss.marginRight);
            font.style.maxWidth = `${rect.width - parseInt(imgCss.marginRight) - parseInt(imgCss.width)}px`;
          } else if (this.repeat <= 100) {
            font.style.maxWidth = `${rect.width}px`;
            this.repeat++;
            setTimeout(() => {
              this.initMiddle();
            }, 20)
          }
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../common/var";
@import "../common/mixin";

%a {
  line-height: 45px; /*no*/
  height: 45px; /*no*/
}

img {
  @include w_h(30px, 30px);
}

.header {
  font-size: 18px; /*no*/
  background-color: white;
  @include border(bottom);
  @extend %a;
  position: relative;

  .back {
    position: absolute;
    @include t_r_b_l(0, 1, 1, 0);

    &.home.weixin {
      i {
        &::after {
          font-style: normal;
          content: '\e602';
        }
      }
    }

    i {
      color: #666666;
      font-family: 'iconfont';
      display: block;
      width: 45px; /*no*/
      height: 45px; /*no*/
      &::after {
        font-style: normal;
        content: '\e61d';
      }
    }
  }

  .close {
    left: 45px;
    min-width: 35px;
    font-size: 16px; /*no*/
    overflow: hidden;
  }

  .middle {
    position: absolute;
    left: 80px;
    right: 80px;
    top: 0;
    bottom: 0;
  }

  .right {
    right: $commonSpace;
    top: 0px;
    position: absolute;
    @extend %a;
    font-size: 16px; /*no*/
    color: $mainColor;
  }
}
</style>



// WEBPACK FOOTER //
// src/plugins/app-header.vue